import { jsx, jsxs } from 'react/jsx-runtime';
import { FlexBox, Box } from '@vp/swan';
import { useContactChannelsContext as z } from './contact-channels14.js';

const s=["en-gb","en-ie"],f=({schedule:o,timezone:r})=>{const{locale:m}=z();return jsx(FlexBox,{flexDirection:"column",style:{width:"100%"},children:o==null?void 0:o.map((n,l)=>jsxs(FlexBox,{justifyContent:"space-between",children:[jsxs(Box,{children:[n.startDay,n.startDay!==n.endDay?jsxs("span",{children:[" – ",n.endDay]}):null]}),jsxs(Box,{children:[n.startTime," – ",n.endTime," ",!s.includes(m.toLowerCase())&&jsx("span",{children:r})]})]},`${n.startTime}–${n.endTime}-${l}`))})};

export { f as CallMeSchedule };
//# sourceMappingURL=contact-channels78.js.map
